import React, { useEffect, useState, useCallback } from "react";
import './styles/App.css';
import twitterLogo from './assets/twitter-logo.svg';
import hypezLogo from './assets/hypezlogo-white.svg';
import {ethers} from "ethers";
import { domainsAbi, domainsAddress } from "./utils/constants";
import polygonLogo from './assets/polygonlogo.png';
import ethLogo from './assets/ethlogo.png';
import { networks } from './utils/networks';


const TWITTER_HANDLE = 'HypeZLabs';
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;
const tld = '.hypez';
const CONTRACT_ADDRESS = '0x02328D1008AB24B643dB76763c058aE03bcCd66E';

const App = () => {
  const [currentAccount, setCurrentAccount] = useState('');
  const [domain, setDomain] = useState('');
  const [record, setRecord] = useState('');
  const [network, setNetwork] = useState('');
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mints, setMints] = useState([]);

    
  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert("Get MetaMask -> https://metamask.io/");
        return;
      }

      const accounts = await ethereum.request({ 
        method: "eth_requestAccounts",
       });
    
      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (error) {
      console.log(error)
    }
  }

  const switchNetwork = async () => {
    if (window.ethereum) {
      try {
        // Try to switch to the Mumbai testnet
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x13881" }], // Check networks.js for hexadecimal network ids
        });
      } catch (error) {
        if (error.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: "0x13881",
                  chainName: "Polygon Mumbai Testnet",
                  rpcUrls: ["https://rpc-mumbai.maticvigil.com/"],
                  nativeCurrency: {
                    name: "Mumbai Matic",
                    symbol: "MATIC",
                    decimals: 18,
                  },
                  blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
                },
              ],
            });
          } catch (error) {
            console.log(error);
          }
        }
        console.log(error);
      }
    } else {
      alert(
        "MetaMask is not installed. Please install it to use this app: https://metamask.io/download.html"
      );
    }
  };

  const checkIfWalletIsConnected = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log('Make sure you have metamask!');
      return;
    } else {
      console.log('We have the ethereum object', ethereum);
    }

    const accounts = await ethereum.request({ method: 'eth_accounts' });
    const isConnected = await ethereum.isConnected();

    if (accounts.length !== 0) {
      const account = accounts[0];
      console.log('Found an authorized account:', account);
      setCurrentAccount(account);
    } else {
      console.log('No authorized account found');
    }

    const chainId = await ethereum.request({ method: 'eth_chainId' });
    setNetwork(networks[chainId]);

    ethereum.on('chainChanged', handleChainChanged);

    function handleChainChanged(_chainId) {
      window.location.reload();
    }
  };

  const mintDomain = async () => {
    if (!domain) {
      return;
    }
    // // Alert the user if the domain is too short
    if (domain.length < 3) {
    alert("Domain must be at least 3 characters long");
    return;
    }
    // Calculate price based on length of domain (change this to match your contract)
    // 3 chars = 0.5 MATIC, 4 chars = 0.3 MATIC, 5 or more = 0.1 MATIC
    const price =
      domain.length === 3 ? "0.5" : domain.length === 4 ? "0.3" : "0.1";
    console.log("Minting domain", domain, "with price", price);
    try {
      const { ethereum } = window;
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          CONTRACT_ADDRESS,
          domainsAbi,
          signer
        );

        console.log("Going to pop wallet now to pay gas...");

        let tx = await contract.register(domain, {
          value: ethers.utils.parseEther(price),
        });

        const receipt = await tx.wait();

        if (receipt.status === 1) {
          console.log(
            "Domain minted! https://mumbai.polygonscan.com/tx/" + tx.hash
          );

          tx = await contract.setRecord(domain, record);
          await tx.wait();

          console.log(
            "Record set! https://mumbai.polygonscan.com/tx/" + tx.hash
          );

          setTimeout(() => {
            fetchMints();
          }, 2000);

          setRecord("");
          setDomain("");
        } else {
          alert("Transaction failed! Please try again");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateDomain = async () => {
    if (!record || !domain) {
      return;
    }
    setLoading(true);
    console.log("Updating domain", domain, "with record", record);
    try {
      const { ethereum } = window;
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          CONTRACT_ADDRESS,
          domainsAbi,
          signer
        );

        let tx = await contract.setRecord(domain, record);
        await tx.wait();
        console.log("Record set https://mumbai.polygonscan.com/tx/" + tx.hash);

        fetchMints();
        setRecord("");
        setDomain("");
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const renderNotConnectedContainer = () => (
    <div className="connect-wallet-container">
      <center><strong><h1>👉 Connect your wallet to get your .HypeZ Domain NFT!</h1></strong></center>
      <br />
      <button onClick={connectWallet} className="cta-button connect-wallet-button">
        Connect Wallet
      </button>
	  
    <span className="Costs">
    
    <br />
    <center><strong><h2>💰 .HypeZ Domain Price:</h2></strong></center>
      
      <h4>⚡️ 3 characters = 0.5 MATIC</h4>
      <h4>⚡️ 4 characters = 0.3 MATIC</h4> 
      <h4>⚡️ 5 or more = 0.1 MATIC</h4>
      <br />
      
      </span>
    </div>
  );

  const renderInputForm = () =>{

    if (network !== 'Polygon Mumbai Testnet') {
      return (
        <div className="connect-wallet-container">
          <h2>Please switch to Polygon Mumbai Testnet</h2>
          <button className='cta-button mint-button' onClick={switchNetwork}>Click here to switch</button>
        </div>
      );
    }
    
    return (
		<div className="form-container">
			<center><strong><h1>💎 Mint your .HypeZ Domain Now!</h1></strong></center>
			<div className="first-row">
				<input
					type="text"
					value={domain}
					placeholder='domain'
					onChange={e => setDomain(e.target.value)}
				/>
				<p className='tld'> {tld} </p>
			</div>

      <input
          type="text"
          value={record}
          placeholder="Where is the HypeZ today?"
          onChange={(e) => setRecord(e.target.value)}
        />
        {/* If the editing variable is true, return the "Set record" and "Cancel" button */}
        {editing ? (
          <div className="button-container">
            {/* This will call the updateDomain function we just made */}
            <button
              className="cta-button mint-button"
              disabled={loading}
              onClick={updateDomain}
            >
              Set record
            </button>
            {/* This will let us get out of editing mode by setting editing to
            false */}
            <button
              className="cta-button mint-button"
              onClick={() => {
                setEditing(false);
              }}
            >
              Cancel
            </button>
          </div>
        ) : (
          // If editing is not true, the mint button will be returned instead
          <button
            className="cta-button mint-button"
            disabled={loading}
            onClick={mintDomain}
          >
            Mint
          </button>
        )}{""}
              <span className="Costs">
              <br/>
      <p>A .hypez domain is unique and can only be minted once. If you try to click on the mint button and your transaction does not start, it is probably because it already exists or exceeds the 10 character limit.</p>
      <br/>
    <center><strong><h2>💰 .HypeZ Domain Price:</h2></strong></center>
      <h4>⚡️ 3 characters = 0.5 MATIC</h4>
      <h4>⚡️ 4 characters = 0.3 MATIC</h4> 
      <h4>⚡️ 5 or more = 0.1 MATIC</h4>
      <h5>(🚀 10 characters max)</h5>
      <br />
      </span>
      </div>
    );
  };

  const renderMints = () => {
    if (currentAccount && mints.length > 0) {
      return (
        <div className="mint-container">
          <p className="subtitle"> <strong>Recently minted domains!</strong></p>
          <div className="mint-list">
            {mints.map((mint, index) => {
              return (
                <div className="mint-item" key={index}>
                  <div className="mint-row">
                    <a
                      className="link"
                      href={`https://testnets.opensea.io/assets/mumbai/${CONTRACT_ADDRESS}/${mint.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <p className="underlined">
                        {" "}
                        {mint.name}
                        {tld}{" "}
                      </p>
                    </a>
                   </div>
                  <p> {mint.record} </p>
                </div>
              );
            })}
          </div>
        </div>
      );
    } 
  };

        const fetchMints = useCallback(async () => {
          try {
            const { ethereum } = window;
            if (ethereum && currentAccount) {
              // You know all this
              const provider = new ethers.providers.Web3Provider(ethereum);
              const signer = provider.getSigner();
              const contract = new ethers.Contract(
                CONTRACT_ADDRESS,
                domainsAbi,
                signer
              );
      
              // Get all the domain names from our contract
              const names = await contract.getAllNames();
      
              // For each name, get the record and the address
              const mintRecords = await Promise.all(
                names.map(async (name) => {
                  const mintRecord = await contract.records(name);
                  const owner = await contract.domains(name);
                  return {
                    id: names.indexOf(name),
                    name: name,
                    record: mintRecord,
                    owner: owner,
                  };
                })
              );
      
              console.log("MINTS FETCHED ", mintRecords);
              setMints(mintRecords);
            }
          } catch (error) {
            console.log(error);
          }
        }, [currentAccount]);

  // This will run any time currentAccount or network are changed
  useEffect(() => {
    if (network === "Polygon Mumbai Testnet") {
      fetchMints();
    }
  }, [currentAccount, network, fetchMints]);

  // This runs our function when the page loads.
  useEffect(() => {
    checkIfWalletIsConnected();
  }, []);

  return (
    <div className="App">
      <div className="container">
        <div className="header-container">
          <header>
            <div className="left">
              <p className="title">HNS ⚡️ HypeZ Name Service</p>
              <p className="subtitle">Get ready to follow the #HYPEZ!</p>
            </div>
    
    <div className="right">
      <img alt="Network logo" className="logo" src={ network?.includes("Polygon") ? polygonLogo : ethLogo} />
      {currentAccount ? (
                <a
                  className="link"
                  href={`https://mumbai.polygonscan.com/address/${currentAccount}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p className="underlined">
                    {" "}
                    Wallet: {currentAccount.slice(0, 6)}...
                    {currentAccount.slice(-4)}{" "}
                  </p>
                </a>
              ) : (
                <p> Not connected </p>
              )}
            </div>
          </header>
        </div>
        
        {!currentAccount && renderNotConnectedContainer()}
		    {currentAccount && renderInputForm()}
        {mints && renderMints()}

        <div className="footer-container">
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        <div className="floating">
			  <div className="hypez-logo">
			  <img alt="HypeZ Logo" className="hypez-logo" src={hypezLogo} />
				</div>
				</div>
          <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
          <a
            className="footer-text"
            href={TWITTER_LINK}
            target="_blank"
            rel="noreferrer"
          >{`Powered by @${TWITTER_HANDLE}`}</a>
        </div>
      </div>
    </div>
  );
};

export default App;